import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FotaBatchDetailsPageComponent } from './fota-batch-details-page.component';

const routes: Routes = [
  {
    path: 'device-fota',
    data: { name: 'Device-Fota', isTab: false },
    component: FotaBatchDetailsPageComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FotaBatchDetailsPageRoutingModule {}
